import { GreetingProtectionTypeEnum } from "../types";
import BaseGreetingProtection from "./BaseGreetingProtection";

export default class VariableCaptchaGreetingProtection extends BaseGreetingProtection {
  type: GreetingProtectionTypeEnum = GreetingProtectionTypeEnum.VariableCaptcha

  variants!: Array<string>
  variant!: string
}
